import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import styles from "../../../styles.module.css";
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip } from "@mui/material";
import {
    AddButton,
    Breadcrumb,
    CustomePopover,
    DeleteDialog,
    ExcelDownload,
    SearchInput,
    StyledTableCell,
    StyledTableRow,
    dateConversion
} from "../../reusableComponent/Reusables";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import customerMasterService from "../../../services/masters/customerMaster.Service";
import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import driverMasterService from "../../../services/masters/driverMaster.Service";
import vehicleloadingService from "../../../services/vehicleloading.Service";

const List_tempo_loadings = () => {
    const login_details = sessionStorage.getItem("loginUser");
    const userD = JSON.parse(login_details);
    const userInfo = userD.result.userInfo;

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState(null);
    const [sortBy, setSortBy] = useState(null);
    const [rows, setRows] = useState([]);
    const [searchKey, setSearchKey] = useState("");
    const totalCount = useSelector((state) => state.customer.total_count || 0);
    const defaultRowsPerPage = useSelector((state) => state.customer.rows_per_page || 15);

    const fields = ["entry_no", "entry_date", "vehicle_no", "driver_name", "challan_type", "to_party", "cylinder_count"];
    const labels = ["Entry No", "Date", "Vehicle No", "Driver Name", "Challan Type", "To Party", "No of Cylinders"];
    const [total_count, setTotalCount] = useState(null);
    
    useEffect(() => {
        setTotalCount(rows[0]?.totalCount);
    }, [rows]);

    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: defaultRowsPerPage,
    });

    const [successMessage, setSuccessMessage] = useState(null);
    const [depotmap, setDepot] = useState({});
    const [customermap, setCustomer] = useState({});
    const [vehiclemap, setVehicle] = useState({});
    const [cylindermap, setCylinder] = useState({});
    const [drivermap, setDriver] = useState({});
    const [openCylinderDialog, setOpenCylinderDialog] = useState(false);
    const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);

    useEffect(() => {
        async function fetchMasterData() {
            try {
                const [depotData, customerData, vehicleData, cylinderData, driverData] = await Promise.all([
                    depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
                    customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
                    vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
                    cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
                    driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
                ]);

                setDepot(Object.fromEntries(depotData.map((d) => [d.depot_id, d.depot_name])));
                setCustomer(Object.fromEntries(customerData.map((c) => [c.cust_id, c.cust_name])));
                setVehicle(Object.fromEntries(vehicleData.map((s) => [s.vehicle_id, s.vehicle_no])));
                setCylinder(Object.fromEntries(
                    cylinderData.map((s) => [
                        s.cyl_id,
                        {
                            cylinder_no: s.cylinder_no,
                            owner: s.owner,
                            customer_id: s.customer_id
                        }
                    ])
                ));
                setDriver(Object.fromEntries(driverData.map((s) => [s.driver_id, s.driver_name])));
            } catch (error) {
                console.error("Data fetching failed", error);
                setSuccessMessage("Error fetching master data");
            }
        }

        fetchMasterData();
    }, []);

    useEffect(() => {
        setController((prev) => ({
            ...prev,
            rowsPerPage: defaultRowsPerPage,
            page: 0,
        }));
    }, [defaultRowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setController((prev) => ({
            ...prev,
            page: newPage,
        }));
    };

    const handleChangeRowsPerPage = (event) => {
        setController((prev) => ({
            ...prev,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0,
        }));
    };

        const fetchData = async () => {
            try {
                const params = {
                page: controller.page,
                size: controller.rowsPerPage,
                searchKey: searchKey,
            }
                const response = await vehicleloadingService.getvehicleloadingList(params);
                setRows(response || []);
            } catch (error) {
              
                console.error("Fetch error:", error);
            }
        };

    const handleSearch = async (e) => {
        const searchValue = e.target.value;
        setSearchKey(searchValue);
        setController((prev) => ({ ...prev, page: 0 }));
        await fetchData();
    };

    useEffect(() => {
        fetchData();
    }, [controller, searchKey]);

    const deleteRecord = async (id) => {
        try {
            await vehicleloadingService.editDeleteTempoloading({
                tempo_loading_id: id,
                changedUpdatedValue: "delete",
            });
            setIsDelete(false);
            setDeleteInfo(null);
            setSuccessMessage("Record deleted successfully");
            await fetchData();
        } catch (error) {
            setSuccessMessage("Error deleting record");
            console.error("Delete error:", error);
        }
    };

    const handleDelete = (data) => {
        setIsDelete(true);
        setDeleteInfo(data);
    };

    const handleClose = () => {
        setIsDelete(false);
        setDeleteInfo(null);
    };

    const handleSort = (field) => {
        const newSortBy = sortBy === field ? null : field;
        setSortBy(newSortBy);

        if (newSortBy) {
            setRows((prevRows) =>
                [...prevRows].sort((a, b) => {
                    if (a[newSortBy] < b[newSortBy]) return -1;
                    if (a[newSortBy] > b[newSortBy]) return 1;
                    return 0;
                })
            );
        } else {
            fetchData();
        }
    };

    const getChallanType = (tableDetails) => {
        try {
            const details = JSON.parse(tableDetails || '[]');
            if (details && details.length > 0) {
                const challanNo = details[0].challan_no;
                return challanNo.includes("EC") ? "EC" : challanNo.includes("DC") ? "DC" : "";
            }
            return "";
        } catch (error) {
            console.error("Error parsing table_details:", error);
            return "";
        }
    };

    const getCylinderCount = (tableDetails) => {
        try {
            const details = JSON.parse(tableDetails || '[]');
            return details.length || 0;
        } catch (error) {
            console.error("Error parsing table_details:", error);
            return 0;
        }
    };

    const getToPartyName = (toLocation) => {
        return depotmap[toLocation] || customermap[toLocation] || toLocation;
    };

    const getOwnerDisplay = (cylinder) => {
        const cylinderInfo = cylindermap[cylinder.cyl_id];
        if (!cylinderInfo) return 'N/A';
        const { owner, customer_id } = cylinderInfo;
        if (owner === 'TGPL') return 'TGPL';
        if (owner === 'customer' && customer_id && customermap[customer_id]) {
            return customermap[customer_id];
        }
        return 'N/A';
    };

    const handleCylinderCountClick = (row) => {
        try {
            const details = JSON.parse(row.table_details || '[]');
            setSelectedCylinderDetails(details);
            setOpenCylinderDialog(true);
        } catch (error) {
            console.error("Error parsing table_details:", error);
            setSuccessMessage("Error loading cylinder details");
        }
    };

    const handleCloseCylinderDialog = () => {
        setOpenCylinderDialog(false);
        setSelectedCylinderDetails([]);
    };

    const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
    const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
    const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
    const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
    const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

    return (
        <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
            <Box className={styles.body}>
                <Breadcrumb routeSegments={[{ name: "Vehicle Loading List" }]} />

                <HeaderSection
                    title="VEHICLE LOADING LIST"
                    searchKey={searchKey}
                    handleSearch={handleSearch}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="Tempo entry List"
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
                />

                <Paper sx={{ width: '100%' }}>
                    <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head} onClick={() => handleSort("entry_no")}>
                                        Entry No
                                        <span className={styles.sort_icon}>{sortBy === "entry_no" ? "▲" : "▼"}</span>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head} onClick={() => handleSort("entry_date")}>
                                        Date
                                        <span className={styles.sort_icon}>{sortBy === "entry_date" ? "▲" : "▼"}</span>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head} onClick={() => handleSort("vehicle_no")}>
                                        Vehicle No
                                        <span className={styles.sort_icon}>{sortBy === "vehicle_no" ? "▲" : "▼"}</span>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head} onClick={() => handleSort("driver_name")}>
                                        Driver Name
                                        <span className={styles.sort_icon}>{sortBy === "driver_name" ? "▲" : "▼"}</span>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head} onClick={() => handleSort("challan_type")}>
                                        Challan Type
                                        <span className={styles.sort_icon}>{sortBy === "challan_type" ? "▲" : "▼"}</span>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head} onClick={() => handleSort("to_party")}>
                                        To Party
                                        <span className={styles.sort_icon}>{sortBy === "to_party" ? "▲" : "▼"}</span>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head} onClick={() => handleSort("no_of_cylinders")}>
                                        No of Cylinders
                                        <span className={styles.sort_icon}>{sortBy === "no_of_cylinders" ? "▲" : "▼"}</span>
                                    </StyledTableCell>
                                    <StyledTableCell align="center" className={styles.table_head}>
                                        Action
                                    </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody sx={{ backgroundColor: '#fff' }}>
                                {Array.isArray(rows) && rows.length > 0 ? (
                                    sortedRows.map((row, index) => (
                                        <StyledTableRow key={row.tempo_loading_id || index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                {row.entry_no}
                                            </StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                {dateConversion(row.entry_date)}
                                            </StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                {vehiclemap[row.vehicle_id] || row.vehicle_id}
                                            </StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                {drivermap[row.driver_id] || row.driver_id}
                                            </StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                {getChallanType(row.table_details)}
                                            </StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                {getToPartyName(row.to_location)}
                                            </StyledTableCell>
                                            <StyledTableCell align="center" className={`${styles.list_table_body}`}>
                                                <Tooltip title="Click here to view cylinder details " arrow>
                                                    <span
                                                        onClick={() => handleCylinderCountClick(row)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {getCylinderCount(row.table_details)}
                                                    </span>
                                                </Tooltip>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <CustomePopover row={row} handleDelete={false} linkTo="/storeEntries/Add-tempo-loadings" showEdit={false} handlePrint={false} />
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))
                                ) : (
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={8} align="center">
                                            No data available
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={total_count || 0}
                        rowsPerPage={controller.rowsPerPage}
                        page={controller.page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>

                <Dialog
                    open={openCylinderDialog}
                    onClose={handleCloseCylinderDialog}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        Cylinder Details ({selectedCylinderDetails.length} Cylinders)
                        <IconButton onClick={handleCloseCylinderDialog}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Table size="small">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Cylinder No</StyledTableCell>
                                    <StyledTableCell>Tag No</StyledTableCell>
                                    <StyledTableCell>Owner</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {selectedCylinderDetails.length > 0 ? (
                                    selectedCylinderDetails.map((cylinder, index) => (
                                        <StyledTableRow key={index}>
                                            <StyledTableCell>{cylinder.cyl_no || 'N/A'}</StyledTableCell>
                                            <StyledTableCell>{cylinder.tag_no || 'N/A'}</StyledTableCell>
                                            <StyledTableCell>{cylinder.owner}</StyledTableCell>
                                        </StyledTableRow>
                                    ))
                                ) : (
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={3} align="center">
                                            No cylinder details available
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )}
                            </TableBody>
                        </Table>
                    </DialogContent>
                </Dialog>

                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.tempo_loading_id || null}
                    displayName={deleteInfo?.entry_no || deleteInfo?.tempo_loading_id || ""}
                />

                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={() => setSuccessMessage(null)}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    );
};

export default List_tempo_loadings;